import { Saga } from "redux-saga";
import { all, call, spawn } from "redux-saga/effects";
import userSaga from "./user/saga";
import claimSaga from "./claim/saga";
import warrntyItemSaga from "./add-warrnty-item/saga";
import contactServiceSaga from "./contact-service/saga";
import aceClaimSaga from "./ace-claim/saga";

export default function* rootSaga() {
  const sagas: Saga[] = [
    userSaga,
    claimSaga,
    warrntyItemSaga,
    contactServiceSaga,
    aceClaimSaga,
  ];

  yield all(
    sagas?.map((saga) =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error("Saga caught exception:", e);
          }
        }
      })
    )
  );
}
